import { createAction } from '@reduxjs/toolkit'
import { userProfileClear } from 'redux/action.types'
import userProfileReducer from './UserProfile.reducer'

export const clearUserProfileState = createAction(userProfileClear)

export default userProfileReducer
